export const UPGRADE_DASHBOARD = 'upgrade_dashboard';
export const UPGRADE_BRAND_LIBRARY = 'upgrade_brand_library';

export const DISMISSED_MODAL_FIELD = {
  [UPGRADE_DASHBOARD]: 'showDashboardModal',
  [UPGRADE_BRAND_LIBRARY]: 'showBrandLibraryModal',
};
